import { ConnectProto } from "@racoon/api";
import { truckTypeFromJSON } from "@racoon/api/src/proto/enums";

/**
 * Константы для работы с изображениями грузовиков
 */

const TRUCK_IMAGES_CONFIG = {
  /** Base URL for S3 storage */
  baseUrl: import.meta.env.VITE_S3_URL as string,
  /** Folder name for truck renders */
  folderName: "truck-renders",
} as const;

/**
 * Дефолтные цвета для разных типов грузовиков
 * Соответствует логике из бэкенда (Python)
 */
const TRUCK_DEFAULT_COLORS: Record<string, string> = {
  TRUCK_TYPE_MSW: "green",
  TRUCK_TYPE_TIPPER: "orange",
  TRUCK_TYPE_LIQUID_WASTE: "gray",
  TRUCK_TYPE_CONSTRUCTION: "blue",
};

/**
 * Генерирует имя файла изображения грузовика на основе его характеристик
 * @param type - Тип грузовика
 * @param model - Модель грузовика
 * @param year - Год выпуска (опционально)
 * @param color - Цвет (опционально)
 * @returns Имя файла изображения
 */
const getTruckImageFileName = (
  type: ConnectProto.TruckType | string | undefined,
  model: string | undefined,
  year?: number | undefined,
  color?: string | undefined,
): string => {
  // Use provided color or default for truck type, or 'white'
  const final_color = color || TRUCK_DEFAULT_COLORS[type || ""] || "white";
  const final_year = year || new Date().getFullYear() - 1;

  return (
    [truckTypeFromJSON(type), model, final_year, final_color]
      .map((v) => (v ? v : ""))
      .join("_")
      .toLowerCase()
      .replace(/ /g, "_") + ".webp"
  );
};

/**
 * Генерирует полный URL изображения грузовика
 * @param type - Тип грузовика
 * @param model - Модель грузовика
 * @param year - Год выпуска (опционально)
 * @param color - Цвет (опционально)
 * @returns Полный URL изображения
 */
export const getTruckImageUrl = (
  type: ConnectProto.TruckType | string | undefined,
  model: string | undefined,
  year?: number | undefined,
  color?: string | undefined,
): string => {
  if (!TRUCK_IMAGES_CONFIG.baseUrl) return "";
  const fileName = getTruckImageFileName(type, model, year, color);
  return `${TRUCK_IMAGES_CONFIG.baseUrl}${TRUCK_IMAGES_CONFIG.folderName}/${fileName}`;
};
